<template>
    <div>
      <div class="product-report" v-html="explain">
      </div>
    </div>
</template>

<script>
    export default {
        name: "product-report",
        props: {
          explain:{
            type: String,
            default: ''
          }
        }
    }
</script>

<style scoped lang="scss">
  @import "../../assets/style/common";
  .product-report{
    h2{
      @include font(22px,#3b6bda);
      line-height: 108px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/system-com/product-report.vue